import React from 'react'

export const WelcomeFooterIcon = () => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" width={43} height={42}>
    <g fill="none" fillRule="evenodd">
      <ellipse
        fill="#FFF"
        id="a"
        cx="21.156"
        cy="20.876"
        rx="20.946"
        ry="20.876"
      />
      <ellipse
        cx="6.02"
        cy="30.857"
        stroke="#60798E"
        strokeWidth={2}
        rx="4.3"
        ry="4.286"
      />
      <ellipse
        cx="23.22"
        cy="30.857"
        stroke="#60798E"
        strokeWidth={2}
        rx="4.3"
        ry="4.286"
      />
      <ellipse
        cx="23.22"
        cy="12.857"
        stroke="#60798E"
        strokeWidth={2}
        rx="4.3"
        ry="4.286"
      />
      <path
        stroke="#60798E"
        strokeLinecap="square"
        strokeWidth={2}
        d="M10.32 30.857h8.6m4.3-12.749v8.463m4.3-14.463h8.855"
      />
      <path
        fill="#0189FF"
        d="M37.62 16.806l4.183-3.221a2 2 0 0 0 0-3.17l-4.183-3.22a2 2 0 0 0-3.22 1.584v6.442a2 2 0 0 0 3.22 1.585z"
      />
    </g>
  </svg>
)
